import { Response } from 'miragejs';
import { StatusCodes as HTTP } from 'http-status-codes';

export default server => {
    server.get('/v1/teams', schema => {
        const { models } = schema.teams.all();

        return models.map(team => ({
            ...team.attrs,
            accountIds: team.attrs.userIds
        }));
    });

    server.post('/v1/teams', (schema, { requestBody }) => {
        const { name, account_ids: accountIds = [] } = JSON.parse(requestBody);

        const team = schema.teams.create({
            name
        });

        const usersModels = [];

        for (const userId of accountIds) {
            const user = schema.users.find(userId);

            usersModels.push(user);
        }

        team.update({ users: usersModels });

        return { ...team.attrs, accountIds };
    });

    server.patch('/v1/teams/:id', (schema, { params: { id }, requestBody }) => {
        const team = schema.teams.find(id);

        if (!team) {
            return new Response(HTTP.NOT_FOUND);
        }

        const { name, account_ids: accountIds = [] } = JSON.parse(requestBody);

        const usersModels = [];

        for (const userId of accountIds) {
            const user = schema.users.find(userId);

            usersModels.push(user);
        }

        team.update({ name, users: usersModels });

        return { ...team.attrs, accountIds };
    });

    server.delete('/v1/teams/:id', (schema, { params: { id } }) => {
        const team = schema.teams.find(id);

        if (team) {
            team.destroy();
        }

        return new Response(HTTP.NO_CONTENT);
    });
};
